import { support } from "@/utils/urlConstants";

export default ({ get, post, put }) => ({
  getSupportRedirect() {
    return get(`${support.redirect}`);
  },
});
